<template>
  <el-tooltip :content="currentTooltipText" :placement="placement">
    <div slot="content" style="width: 100px; text-align: center;">
      {{ currentTooltipText }}
    </div>
    <span
      v-clipboard
      class="copy-click"
      :data-clipboard-text="text"
      @click="click"
      @mouseover="mouseover"
    >
      <slot>
        <i class="ion ion-clipboard" />
        <Fader ref="fader">
          <i class="ion ion-checkmark" />
        </Fader>
      </slot>
    </span>
  </el-tooltip>
</template>

<script>
import Fader from 'components/Fader.vue'

const INITIAL_TEXT = 'Click to copy'
const COPIED_TEXT = 'Copied'

export default {
  components: { Fader },
  props: {
    text: { type: String, default: '' },
    tooltipText: { type: String, default: INITIAL_TEXT },
    placement: { type: String, default: 'top' },
  },
  data() {
    return {
      currentTooltipText: this.tooltipText,
    }
  },
  methods: {
    mouseover() {
      this.currentTooltipText = this.tooltipText
    },
    click() {
      this.currentTooltipText = COPIED_TEXT
      if (this.$refs.fader) {
        this.$refs.fader.show()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.copy-click {
  &:hover {
    cursor: pointer;
  }
  .fader {
    display: inline-block;
    width: 50px;
    color: $green;
  }
}
</style>
